export const ApiSettingsMail = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/mails/${id}`, payload)
    return result.data
  }

  const find = async (id) => {
    const result = await axios.get(`/api/settings/mails/${id}`)
    return result.data
  }

  const load = async () => {
    const result = await axios.get('api/settings/mails/')
    return result.data
  }

  return {
    mailSettingsFind: find,
    mailSettingsLoad: load,
    mailSettingsSave: save
  }
}
